import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const SplitInboundDeliveryMutation = graphql(/* GraphQL */ `
  mutation splitInboundDelivery(
    $splitInboundDeliveryInput: SplitInboundDeliveryInput!
  ) {
    splitInboundDelivery(input: $splitInboundDeliveryInput) {
      inboundDeliverySplitOutput {
        ...InboundDeliverySplitOutput
      }
    }
  }
`);
